import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import MediaBanner from './media-banner';
import MediaList from './media-lists'; 

function MediaPage () {
    return(
      <Fragment> 
      <Header />  
      <MediaBanner />     
      <MediaList />  
      <Footer /> 
      </Fragment> 
    );
}
export default MediaPage;